import { Box, keyframes, styled } from '@mui/material';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

export const LoadingDotsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 10,
});

export const Dot = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  margin: '0 4px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '50%',
  animation: `${bounce} 1.4s infinite ease-in-out both`,
  display: 'inline-block',

  '&:nth-child(1)': {
    animationDelay: '-0.32s',
  },
  '&:nth-child(2)': {
    animationDelay: '-0.16s',
  },
}));
